import { Component, input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CardSummarySinglelineComponent } from "src/app/core/card-summary-singleline/card-summary-singleline.component";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { Subject, take } from 'rxjs';
import { GridColConfig } from 'src/app/core/custom-grid/custom-grid';
import { CustomOverlayMessaggeComponent } from 'src/app/core/custom-overlay-messagge/custom-overlay-messagge.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { GestioneStepService } from './gestione-step.service';
import { StepDto } from './step-dto';
import { MatMenuModule } from "@angular/material/menu";
import { ToastService } from 'src/app/core/toast/toast.service';



@Component({
  selector: 'app-gestione-step',
  imports: [CardSummarySinglelineComponent, MatIconModule, MatButtonModule, MatMenuModule],
  templateUrl: './gestione-step.component.html',
  styleUrl: './gestione-step.component.scss'
})
export class GestioneStepComponent implements OnInit, OnDestroy {

  @ViewChild(CustomOverlayMessaggeComponent) overlayMessagge: CustomOverlayMessaggeComponent | undefined;
  readonly idMission = input.required<string>();

  options: GridColConfig[] = [];
  steps: StepDto[] = [];

  private theEnd$ = new Subject<void>();


  constructor(
    private localstorage: LocalStorageService,
    private router: Router,
    private stepService: GestioneStepService,
    private toast: ToastService
  ) {
  }



  ngOnInit(): void {
    this.getSteps();
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }

  getSteps(): void {
    this.stepService.getAllByMission(this.idMission()).pipe(take(1)).subscribe({
      next: (data: StepDto[]) => {
        this.steps = data;
      }
    })
  }

  btnClick(event: any) {
    if (event.action == 'modifica') {
      this.edit(event.data.id)
    }
    if (event.action == 'elimina') {

      this.overlayMessagge?.showDialog();
      this.overlayMessagge!.deleteItem = event.data.id;
    }

  }

  edit(id: string): void {
    this.router.navigate([`/home/step/${id}`]);
  }


  add(): void {
    this.router.navigate([`/home/step/new`, this.idMission()]);
  }

  delete(id: string) {
    this.stepService.delete(id).pipe(take(1)).subscribe({
      next: () => {
        this.toast.success('Step eliminato');
        this.getSteps();
      }
    })
  }



}
